import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const loadUser = createAsyncThunk(
    'user/loadUser',
    async ({token, username}) => {
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/user/users/${username}`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        userLoading: false,
        failedToLoadUser: false,
        userInfo: {
            username: ""
        }
    },
    reducers: {
        changeUsername: (state, action) => {
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    username: action.payload
                }
            }
        },
        clearUser: (state) => {
            return {
                ...state,
                userInfo: {
                    username: ""
                }
            }
        }
    },
    extraReducers: {
        [loadUser.pending]: (state) => {
            return {
                ...state,
                userLoading: true,
                failedToLoadUser: false
            }
        },
        [loadUser.fulfilled]: (state, action) => {
            return {
                ...state,
                userInfo: action.payload,
                userLoading: false,
                failedToLoadUser: false
            }
        },
        [loadUser.rejected]: (state) => {
            return {
                ...state,
                userLoading: false,
                failedToLoadUser: true
            }
        }
    }
})

export const selectUser = (state) => state.user.userInfo;

export const { changeUsername, clearUser } = userSlice.actions;

export default userSlice.reducer;